import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getAdmins = createAsyncThunk(
  "Employees/getAdmins",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getUsers = createAsyncThunk(
  "Employees/getUsers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/users`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const addAdmins = createAsyncThunk(
  "Employees/addAdmins",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateAdmins = createAsyncThunk(
  "Employees/updateAdmins",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteAdmins = createAsyncThunk(
  "Employees/deleteAdmins",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/admins/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getAdminId = createAsyncThunk(
  "Admin/getAdminId",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/admins/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getSpecializationEmployees = createAsyncThunk(
  "Employees/getSpecializationEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/specializations`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addSpecializationEmployees = createAsyncThunk(
  "Employees/addSpecializationEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/specializations`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateSpecializationEmployees = createAsyncThunk(
  "Employees/updateSpecializationEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/specializations/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteSpecializationEmployees = createAsyncThunk(
  "Employees/deleteSpecializationEmployees",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/specializations/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getOfficeServices = createAsyncThunk(
  "Employees/getOfficeServices",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/office_services`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addOfficeServices = createAsyncThunk(
  "Employees/addOfficeServices",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/office_services`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateOfficeServices = createAsyncThunk(
  "Employees/updateOfficeServices",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/office_services/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteOfficeServices = createAsyncThunk(
  "Employees/deleteOfficeServices",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/office_services/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getOffice = createAsyncThunk(
  "Employees/getOffice",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/offices`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addOffice = createAsyncThunk(
  "Employees/addOffice",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/offices`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateOffice = createAsyncThunk(
  "Employees/updateOffice",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/offices/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteOffice = createAsyncThunk(
  "Employees/deleteOffice",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/offices/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getEmployees = createAsyncThunk(
  "Employees/getEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/employees`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateEmployees = createAsyncThunk(
  "Employees/updateEmployees",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/employees/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteEmployees = createAsyncThunk(
  "Employees/deleteEmployees",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/employees/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getEmployeesStatistics = createAsyncThunk(
  "Employees/getEmployeesStatistics",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/employee_statistic/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getEmployeesStatisticsReport = createAsyncThunk(
  "Employees/getEmployeesStatisticsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/employee_statistic_report/${data.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getOfficeStatistics = createAsyncThunk(
  "Employees/getOfficeStatistics",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/office_statistic/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getOfficeStatisticsReport = createAsyncThunk(
  "Employees/getOfficeStatisticsReport",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/office_statistic_report/${data.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getHireLawers = createAsyncThunk(
  "Contract/getHireLawers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultations`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateHireLawers = createAsyncThunk(
  "Contract/updateHireLawers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultations/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteHireLawers = createAsyncThunk(
  "Contract/deleteHireLawers",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultations/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const EmployeesSlice = createSlice({
  name: "Employees",
  initialState: {
    isEmployeesLoading: false,
    error: null,
    EmpolyeesArray: null,
    ConsultantArray: null,
    AdministratorArray: null,
    SpecializationEmployeesArray: null,
    OfficeServicesArray: null,
    officesArray: null,
    adminsArray: null,
    AdminIDArray: null,
    EmployeesStatisticsArray: null,
    EmployeesStatisticsReportArray: null,
    OfficeStatisticsArray: null,
    OfficeStatisticsReportArray: null,
    UsersData :null
  },

  extraReducers: (builder) => {
    builder

      .addCase(getUsers.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.UsersData = action.payload.data;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(getAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.adminsArray = action.payload.data;
      })
      .addCase(getAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(getAdminId.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getAdminId.fulfilled, (state, action) => {
        state.AdminIDArray = action.payload.data;
        state.isEmployeesLoading = false;
      })
      .addCase(getAdminId.rejected, (state) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(addAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(updateAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(updateAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(updateAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(deleteAdmins.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(deleteAdmins.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.adminsArray = state.adminsArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteAdmins.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(getEmployees.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getEmployees.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;

        if (action.meta.arg.type === "lawyer") {
          state.EmpolyeesArray = action.payload.data;
        } else if (action.meta.arg.type === "consultant") {
          state.ConsultantArray = action.payload.data;
        } else if (action.meta.arg.type === "administrator") {
          state.AdministratorArray = action.payload.data;
        }
      })
      .addCase(getEmployees.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getSpecializationEmployees.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getSpecializationEmployees.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.SpecializationEmployeesArray = action.payload.data;
      })
      .addCase(getSpecializationEmployees.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(addSpecializationEmployees.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(addSpecializationEmployees.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addSpecializationEmployees.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(updateSpecializationEmployees.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(updateSpecializationEmployees.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(updateSpecializationEmployees.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(deleteSpecializationEmployees.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(deleteSpecializationEmployees.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.SpecializationEmployeesArray = state.SpecializationEmployeesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteSpecializationEmployees.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getOfficeServices.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getOfficeServices.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.OfficeServicesArray = action.payload.data;
      })
      .addCase(getOfficeServices.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(addOfficeServices.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(addOfficeServices.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addOfficeServices.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(updateOfficeServices.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(updateOfficeServices.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(updateOfficeServices.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(deleteOfficeServices.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(deleteOfficeServices.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.OfficeServicesArray = state.OfficeServicesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteOfficeServices.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getOffice.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getOffice.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.officesArray = action.payload.data;
      })
      .addCase(getOffice.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(addOffice.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(addOffice.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(addOffice.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(updateOffice.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(updateOffice.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(updateOffice.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })
      .addCase(deleteOffice.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(deleteOffice.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.officesArray = state.officesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteOffice.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getEmployeesStatistics.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getEmployeesStatistics.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.EmployeesStatisticsArray = action.payload.data;
      })
      .addCase(getEmployeesStatistics.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getEmployeesStatisticsReport.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getEmployeesStatisticsReport.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.EmployeesStatisticsReportArray = action.payload.data;
      })
      .addCase(getEmployeesStatisticsReport.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getOfficeStatistics.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getOfficeStatistics.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.OfficeStatisticsArray = action.payload.data;
      })
      .addCase(getOfficeStatistics.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      })

      .addCase(getOfficeStatisticsReport.pending, (state) => {
        state.isEmployeesLoading = true;
      })
      .addCase(getOfficeStatisticsReport.fulfilled, (state, action) => {
        state.isEmployeesLoading = false;
        state.OfficeStatisticsReportArray = action.payload.data;
      })
      .addCase(getOfficeStatisticsReport.rejected, (state, action) => {
        state.isEmployeesLoading = false;
      });
  },
});

export default EmployeesSlice.reducer;
